import { Flex, rem, Text, ThemeIcon } from "@mantine/core";
import React from "react";
import { MdCheck, MdClose } from "react-icons/md";
import { usePingPyCeilingQuery } from "./pyCeiling/pyCeilingRTK";

export const PingToPyCeiling: React.FC = () => {
  const { error, isSuccess } = usePingPyCeilingQuery();

  return (
    <Flex align="center">
      <Text>AI:</Text>
      {error != null ? <InvalidIcon /> : isSuccess === true ? <ValidIcon /> : null}
    </Flex>
  );
};

export default PingToPyCeiling;

export const ValidIcon = () => {
  return (
    <ThemeIcon color="green" size={24} radius="xl">
      <MdCheck style={{ width: rem(16), height: rem(16) }} />
    </ThemeIcon>
  );
};

export const InvalidIcon = () => {
  return (
    <ThemeIcon color="red" size={24} radius="xl">
      <MdClose style={{ width: rem(16), height: rem(16) }} />
    </ThemeIcon>
  );
};
